import { SectionInitData } from "./Game World/Sections/Section";

export class PlayerSettings {
    /**
     * (RO) Offsety jednotlivych postav hrace. Zaznamy jsou serazeny podle pozice na ose Y od nejmensi.
     * Zaroven urcuje pocet postav hrace
     */
    get charsOffset(): pc.Vec2[] { return this._charsOffset; }
    private _charsOffset: pc.Vec2[]

    /**
     * (RO) Pocet postav hrace
     */
    get charCnt(): number { return this._charsOffset.length; }

    /**
     * (RO) Odstup od horniho okraje levelu (po dosazeni teto pozice dojde ke zmene smeru pohybu hrace)
     */
    get topPadding(): number { return this._topPadding; }
    private _topPadding: number;

    /**
     * (RO) Odstup od dolniho okraje levelu (po dosazeni teto pozice dojde ke zmene smeru pohybu hrace)
     */
    get botPadding(): number { return this._botPadding; }
    private _botPadding: number;

    /**
     * (RO) Startovni smer pohybu hrace na ose Z (1 = smerem dolu, -1 = smerem nahoru)
     */
    get startDir(): number { return this._startDir; }
    private _startDir: number;

    /**
     * (RO) Startovni pozice na ose Z
     */
    get startPadding(): number { return this._startPadding; }
    private _startPadding: number;

    /**
     * (RO) Rychlost chuze v jednotkach za vterinu
     */
    get walkSpeed(): number { return this._walkSpeed; }
    private _walkSpeed: number;

    //-------------------------------------------------------------------------
    /**
     * 
     * @param charsOffset Offsety pro jednotlive postavy hrace (x, z)
     * @param topPadding Velikost horniho okraje herniho sveta
     * @param botPadding Velikost dolniho okraje herniho sveta
     * @param startPadding Startovni odstup od okraje (bud od dolniho nebo horniho podle hodnoty startDir)
     * @param startDir Startovni smer hrace (1 = smer dolu, -1 = smer nahoru)
     * @param walkSpeed Rychlost chuze v jednotkach za vterinu
     */
    //-------------------------------------------------------------------------
    constructor(charsOffset: pc.Vec2[], topPadding: number, botPadding: number, startPadding: number, startDir: number, walkSpeed = 1.4) {
        this._charsOffset = charsOffset;
        this._topPadding = topPadding;
        this._botPadding = botPadding;
        this._startPadding = startPadding;
        this._startDir = startDir;
        this._walkSpeed = walkSpeed;

        // Seradit offsety podle pozice Y
        this._charsOffset.sort((a: pc.Vec2, b: pc.Vec2): number => {
            return a.y - b.y;
        });
    }
}



export class DeliveryBonusSettings {
    /**
     * (RO) Delka bonusu v ms. Po uplynuti teto doby hrac ziska jen minBonus
     */
    get bonusLen(): number { return this._bonusLen; }
    private _bonusLen: number;

    /**
     * (RO) Minimalni hodnota bonusu. Ten hrac dostane po vyprseni casu na bonus
     */
    get minBonus(): number { return this._minBonus; }
    private _minBonus: number;

    /**
     * (RO) Maximalni hodnota bonusu. Ten by hrac dostal, kdyby bonusu dorucil okamzite
     */
    get maxBonus(): number { return this._maxBonus; }
    private _maxBonus: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(bonusLen: number, minBonus: number, maxBonus: number) {
        this._bonusLen = bonusLen * 1000;
        this._minBonus = minBonus;
        this._maxBonus = maxBonus;
    }
}



export class ObstacleSettings {
    /**
     * (RO) Maximalni pocet soucasne zobrazenych aut v cele scene
     */
    get maxSimCars(): number[] { return this._maxSimCars; }
    private _maxSimCars: number[];

    /**
     * (RO) Maximalni pocet soucasne zobrazenych krabic v cele scene
     */
    get maxSimBoxes(): number { return this._maxSimBoxes; }
    private _maxSimBoxes: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(maxSimCars: number[], maxSimBoxes: number) {
        this._maxSimCars = maxSimCars;
        this._maxSimBoxes = maxSimBoxes;
    }
}



export class LevelSettings {
    /**
     * (RO) Nastaveni sekci herniho sveta
     */
    get gameWorld(): SectionInitData[] { return this._gameWorld; }
    private _gameWorld: SectionInitData[];

    /**
     * (RO) Nastaveni hrace
     */
    get player(): PlayerSettings { return this._player; }
    private _player: PlayerSettings;

    /**
     * (RO) Nastaveni bonusu za doruceni balicku
     */
    get deliveryBns(): DeliveryBonusSettings { return this._deliveryBns; }
    private _deliveryBns: DeliveryBonusSettings;

    /**
     * (RO) Nastaveni prekazek
     */
    get obstacles(): ObstacleSettings { return this._obstacles; }
    private _obstacles: ObstacleSettings;

    get shadowDistance(): number { return this._shadowDis; }
    private _shadowDis: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(gameWorld: SectionInitData[], player: PlayerSettings, deliveryBns: DeliveryBonusSettings, shadowDistance: number, obstacles?: ObstacleSettings) {
        this._gameWorld = gameWorld;
        this._player = player;
        this._deliveryBns = deliveryBns;
        this._shadowDis = shadowDistance;
        this._obstacles = obstacles;
    }
}